import { createRouter } from "@tanstack/react-router";
import { stopLive } from "./lib/live";
import { queryClient, setUnauthorizedHandler } from "./query-client";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

setUnauthorizedHandler(() => {
  const here = router.state.location;
  if (here.pathname === "/login") return;
  stopLive();
  queryClient.clear();
  void router.navigate({ to: "/login", search: { redirect: here.href } });
});
